import { render } from "./PaginationButton.vue?vue&type=template&id=3f3001a6"
import script from "./PaginationButton.vue?vue&type=script&lang=js"
export * from "./PaginationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__